import React from "react";

const MoonIcon = () => {
  return (
    <>
      <svg width="20.215" height="20.215" viewBox="0 0 20.215 20.215">
        <path
          id="Icon_open-moon"
          data-name="Icon open-moon"
          d="M7.067,0A10.378,10.378,0,1,0,20.215,13.147a10.76,10.76,0,0,1-3.326.572A10.39,10.39,0,0,1,6.5,3.326,10.045,10.045,0,0,1,7.067,0Z"
          fill="gray"
        />
      </svg>
    </>
  );
};

export default MoonIcon;
